import { combineReducers } from 'redux'
import { get, uniqBy } from 'lodash'

import accountsActionTypes from 'app_modules/accounts/constants'
import initialState from 'app_modules/store/initialState.json'
import profileActionTypes from 'app_modules/profile/constants'
import sessionActionTypes from 'app_modules/session/constants'

export const members = (state = initialState.accounts.members, { type, payload }) => {
  switch (type) {
    case accountsActionTypes.FETCH_MY_MEMBERS_REQUEST:
      return { ...state, isFetching: true, list: payload === 1 ? [] : state.list }

    case accountsActionTypes.FETCH_MY_MEMBERS_FAILURE:
      return { ...state, isFetching: false, list: [], meta: { morePages: false } }

    case accountsActionTypes.FETCH_MY_MEMBERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: uniqBy([...state.list, ...get(payload, 'profiles', [])], 'id'),
        meta: payload.updateCounters
          ? get(payload, 'meta', initialState.accounts.members.meta)
          : {
              ...get(payload, 'meta', initialState.accounts.members.meta),
              totalObjects: state.meta.totalObjects,
            },
      }

    case profileActionTypes.EDIT_DEPARTMENT_SUCCESS:
      return {
        ...state,
        list: state.list.map(profile => {
          if (profile.id === payload.id) {
            return {
              ...profile,
              department: payload.department,
            }
          }
          return profile
        }),
      }

    case sessionActionTypes.RESET_STATE:
      return initialState.accounts.members

    default:
      return state
  }
}

export const limitedMembers = (state = initialState.accounts.limitedMembers, { type, payload }) => {
  switch (type) {
    case accountsActionTypes.FETCH_LIMITED_MEMBERS_REQUEST:
      return { ...state, isFetching: true, list: payload === 1 ? [] : state.list }

    case accountsActionTypes.FETCH_LIMITED_MEMBERS_FAILURE:
      return { ...state, isFetching: false, list: [], meta: { morePages: false } }

    case accountsActionTypes.FETCH_LIMITED_MEMBERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: uniqBy([...state.list, ...get(payload, 'profiles', [])], 'id'),
        meta: payload.updateCounters
          ? get(payload, 'meta', initialState.accounts.limitedMembers.meta)
          : {
              ...get(payload, 'meta', initialState.accounts.limitedMembers.meta),
              totalObjects: state.meta.totalObjects,
            },
      }

    case profileActionTypes.EDIT_DEPARTMENT_SUCCESS:
      return {
        ...state,
        list: state.list.map(profile => {
          if (profile.id === payload.id) {
            return {
              ...profile,
              department: payload.department,
            }
          }
          return profile
        }),
      }

    case sessionActionTypes.RESET_STATE:
      return initialState.accounts.limitedMembers

    default:
      return state
  }
}

export default combineReducers({
  members,
  limitedMembers,
})
